export enum EPravidlaOdkupu {
    O = 'O',
    P = 'P',
    OP = 'OP',
    V = 'V',
    OVP = 'OVP',
    OV = 'OV',
    VE = 'VE'
}
